<div id="dailogMsgPopup" class="dialog-confirm">
  <div class="dailogMsgPopupSec">
    <a (click)="closeDialog()" class="modal-close waves-effect closebtncls"><i class="material-icons btn-floating btn-small waves-effect waves-light cross-icon-bg #2196f3"></i></a>
    <div class="dailogMsgPopupContentCls addCls_{{dialogMsgModel.modelType}}">
      <span class="btn-floating" *ngIf="dialogMsgModel.modelType=='ERROR'"><i  class="material-icons">&#xE14C;</i></span>
      <span class="btn-floating" *ngIf="dialogMsgModel.modelType=='SUCCESS'"><img src="./assets/images/cong-popup-img.png" /></span>
      <span class="btn-floating" *ngIf="dialogMsgModel.modelType=='CONFIRMATION'"><i class="material-icons">&#xE645;</i></span>
      <span class="btn-floating" *ngIf="dialogMsgModel.modelType=='BROKEN'"><i class="material-icons">&#xE645;</i></span>
      <span class="btn-floating" *ngIf="dialogMsgModel.modelType=='VALIDATION'"><i class="material-icons">&#xE612;</i></span>
      <span class="btn-floating" *ngIf="dialogMsgModel.modelType=='LOGOUT'"><img src="./assets/images/logout_popup.png" /></span>
      <h4 class="congTitle">{{ dialogMsgModel.msgTitle }}</h4>
      <h5 class="congMsg">{{ dialogMsgModel.msg }}</h5>
      <div class="dialog-default-btn-section" md-dialog-actions *ngIf="dialogMsgModel.showDefaultBtn && !dialogMsgModel.isConfirmBox">
        <button md-button (click)="closeDialog()">{{ dialogMsgModel.defaultBtnCaption }}</button>
      </div>
      <div class="dialog-confirm-btn-section" md-dialog-actions *ngIf="dialogMsgModel.isConfirmBox">
        <button md-button md-dialog-close="1">{{ dialogMsgModel.confirmBtnCaption }}</button>
        <button md-button md-dialog-close="0">{{ dialogMsgModel.cancelBtnCaption }}</button>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/dialog-confirm-component/dialog-confirm-component.component.html